import { VenereBox, VenereButton } from "../ui"
import VenereDisplay from "../ui/icons/VenereDisplay"

const VenereBloodBox = () => {
    return (
        <VenereBox variant="sky" className="w-full max-w-[800px]">
            <div className="bg-white rounded-lg p-4 self-center w-full flex flex-col items-center gap-4">
                <div className="venere-text-primary text-center">
                    Tieni sotto controllo la tua salute
                </div>
                <div className="venere-text-secondary text-center">
                    Cosa dicono i tuoi esami del sangue?
                </div>
                <VenereDisplay className="w-20 h-20 text-venere-royal"/>
                <VenereButton onClick={() => window.alert("Presto da te!")}>
                    Monitora i tuoi parametri
                </VenereButton>
            </div>
        </VenereBox>
    )
}

export default VenereBloodBox
